<template>
  <!-- 包裝 v-img：載入中顯示 shimmer 佔位(載完自動移除)，其餘屬性/事件原樣轉發 -->
  <v-img class="taro-skel-img" v-bind="$attrs" v-on="$listeners">
    <template #placeholder>
      <div class="taro-img-skeleton"></div>
    </template>
    <slot />
  </v-img>
</template>

<script>
export default {
  name: "SkeletonImg",
  inheritAttrs: false,
};
</script>

<style scoped>
/* 載入前先撐出高度，讓 shimmer 可見並減少版面跳動 */
.taro-skel-img {
  min-height: 120px;
}
.taro-img-skeleton {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(100deg, #ececec 30%, #f7f7f7 50%, #ececec 70%);
  background-size: 200% 100%;
  animation: taro-shimmer 1.2s ease-in-out infinite;
  border-radius: inherit;
}
@keyframes taro-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
